import { FC } from "react";
import FormBoxTable from "./FormBoxTable";
import FormBoxStatus from "./FormBoxStatus";
import style from "./formBoxMain.module.css";

const FormBoxWrapper: FC<any> = () => {
  return (
    <div className={style.formbox_page_wrapper}>
      <FormBoxStatus />
      <FormBoxTable />
    </div>
  );
};

export default FormBoxWrapper;
